define(['jquery', 'jquery.transit', 'modernizr', 'container', 'slider', 'preloader', 'jump'],
    function ($, transit, modernizr, container, sliderFactory, preloader, jumpFactory) {

        return (function () {

            const name = 'module-media-slider';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            const slider = sliderFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                touchStart: 0,
                touchDiff: 0,
                touchStartY: 0,
                touchDiffY: 0,

                slideStarted: false,
                endTrans: false,
                interval: '', /* interval handler */
            };

            view.startup = function () {
                preloader.setPreloadBulk(name, view.publicVars.preloadTab);

                slider.init(view.publicVars.sliderSetup);
                slider.setCallback('beforeSlideChange', view.methods.beforeSlideChange);
                slider.setCallback('afterSlideChange', view.methods.afterSlideChange);

            };

            view.bind = function () {
                $(view.publicVars.cssId.mediaSliderMobileDetailsWrapperCls).bind('touchstart', function(e) {
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseDown(touch);
                });


                $(view.publicVars.cssId.mediaSliderMobileDetailsWrapperCls).bind('touchmove', function(e) {
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseMove(touch, e);
                });

                $(view.publicVars.cssId.mediaSliderMobileDetailsWrapperCls).bind('touchend', function(e) {
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseUp(touch);
                });
            };

            view.methods = {

                slideMouseDown: function(e) {

                    if (!view.privateVars.slideStarted)
                    {
                        view.privateVars.touchStart = e.pageX;
                        view.privateVars.touchStartY = e.pageY;

                        view.privateVars.slideStarted = true;

                    }

                    //return false;

                },

                slideMouseMove: function(e, ev) {

                    if (view.privateVars.slideStarted && !view.privateVars.endTrans)
                    {
                        view.privateVars.touchDiff = view.privateVars.touchStart - e.pageX;
                        view.privateVars.touchDiffY = view.privateVars.touchStartY - e.pageY;

                        // if (view.privateVars.touchDiff < -40) {
                        //     slider.changeSlideLeft();
                        //
                        // } else if (view.privateVars.touchDiff > 40) {
                        //     slider.changeSlideRight();
                        // }

                        if (Math.abs(view.privateVars.touchDiff) >= Math.abs(view.privateVars.touchDiffY)) {
                            ev.preventDefault();
                        }
                    }

                    //return false;
                },

                slideMouseUp: function(e) {

                    if (view.privateVars.slideStarted)
                    {
                        view.privateVars.endTrans = true;
                        if (view.privateVars.touchDiff < -40) {
                            slider.changeSlideLeft();
                        } else if (view.privateVars.touchDiff > 40) {
                            slider.changeSlideRight();
                        } else {

                            view.privateVars.touchDiff = 0;
                            view.privateVars.touchStart = 0;

                            view.privateVars.touchDiffY = 0;
                            view.privateVars.touchStartY = 0;


                            view.privateVars.slideStarted = false;
                            view.privateVars.endTrans = false;
                        }
                    } else {
                        view.privateVars.slideStarted = false;
                        view.privateVars.endTrans = false;
                    }
                },

                beforeSlideChange: (data) => {
                    const title = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'title');
                    const description = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'description');
                    const moreLink = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'more.link');
                    const moreLinkTarget = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'more.link.target');

                    $(view.publicVars.cssId.mediaSliderMobileDetailsInnerCls).css({opacity: 0, visibility: 'hidden'});
                    $(view.publicVars.cssId.mediaSliderMobileLoadMoreLoadeCls).css({display: 'block', opacity: 0});
                    $(view.publicVars.cssId.mediaSliderMobileLoadMoreLoadeCls).transit({opacity: 1}, 100);

                    $(view.publicVars.cssId.mediaSliderMobileDetailsHeaderCls).html(title);
                    $(view.publicVars.cssId.mediaSliderMobileDetailsDescriptionCls).html(description);
                    $(view.publicVars.cssId.mediaSliderMobileDetailsWrapperCls).attr('href', moreLink);
                    $(view.publicVars.cssId.mediaSliderMobileDetailsWrapperCls).attr('target', moreLinkTarget);
                    $(view.publicVars.cssId.mediaSliderMobileDetailsCls).css({'minHeight': '100px'});

                    $(view.publicVars.cssId.mediaSliderMobileDetailsCls).css({display: 'block', height: 'auto'});
                },

                afterSlideChange: (data) => {

                    view.privateVars.touchDiff = 0;
                    view.privateVars.touchStart = 0;

                    view.privateVars.touchDiffY = 0;
                    view.privateVars.touchStartY = 0;


                    view.privateVars.slideStarted = false;
                    view.privateVars.endTrans = false;

                    $(view.publicVars.cssId.mediaSliderMobileDetailsCls).css({'minHeight': '0'});
                    $(view.publicVars.cssId.mediaSliderMobileLoadMoreLoadeCls).css({display: 'none'});
                    $(view.publicVars.cssId.mediaSliderMobileDetailsInnerCls).css({
                        opacity: 0,
                        visibility: 'visible'
                    });
                    $(view.publicVars.cssId.mediaSliderMobileDetailsInnerCls).transit({opacity: 1}, 200);
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
